var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('buttton',{staticClass:"btn__component__bg__gradient",on:{"click":function($event){return _vm.edit()}}},[_c('span',{style:({ fontSize: _vm.getFontSize, lineHeight: _vm.getLineHeight })},[_vm._v(_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }